import React from 'react';

export const MOVE_UP = 'MOVE_UP';
export const MOVE_DOWN = 'MOVE_DOWN';
export const DELETE = 'DELETE';

/**
 * A button inside the clue list item on the clues page for navigating:  either up, down, or delete.
 */
export const ClueNavButton = ( props ) => {

    const {index, nav, type, text, iconName, isDanger } = props;
    const linkClass = `btn btn-default remove-button`;
    const iconClass = `larger-font fa fa-${iconName}`;

    // Make the padding small on our buttons, and have a red version of the button for delete.
    const style = {
        padding: '.175rem .4rem .175rem .4rem'
    };
    //        padding: '.125rem .3rem .125rem .3rem'
    const styleDanger = {
        padding: '.175rem .4rem .175rem .4rem',
        color: '#A00',
    };
    const appliedStyle = isDanger ? styleDanger : style;

    return (
        <a style={appliedStyle}
           title={text}
           className={linkClass}
           data-index={index-1}
           onClick={ (e) => nav(e, type) }>
            <span className={iconClass} >
            </span></a>
    )
};



// WEBPACK FOOTER //
// ./src/components/clues/ClueNavButton.js